import { Pipe, PipeTransform } from '@angular/core';
import { TicketThreadEntry } from '@zero/shared/util-models';

/**
 * Format the ticket entry type (like 'Ticket' or 'Antwort')
 */
@Pipe({
  name: 'entryType',
  standalone: true,
})
export class EntryTypePipe implements PipeTransform {
  public transform(thread: TicketThreadEntry): string {
    if (!thread) {
      return '';
    }

    switch (thread.entryType) {
      case 'ticket':
        return 'Ticket';
      case 'comment':
        return 'Antwort';
      case 'response':
        return 'Antwort';
      default:
        return '';
    }
  }
}
